import React, { Component } from "react";
import ToggleButton from "./Toggle-button";
import { capitalizeString } from "./HelperFunctions";
import { connect } from "react-redux";
import TimePicker from 'react-time-picker';

const mapStateToProps = (state) => ({
  //hours
  opening_hours: state.opening_hours,
  closing_hours: state.closing_hours,
});
export default connect(mapStateToProps)(
  class time_input extends Component {

    constructor(props) {
      super(props);
      this.state = {
        opened: this.props.defaultstate === "closed" ? false : true,
        hours: this.props.openHours || [],
      };

      this.label = capitalizeString(this.props.label);
    }



    toggle = () => {
      // Auto-create an hour when the day is opened
      //  

      if (this.state.hours.length === undefined) {
        this.addHours();
      }

      this.setState(
        prevState => ({ opened: !prevState.opened }),
        () => {
          setTimeout(this.updateHours, 0);
        }
      );
    };
    deleteHour = (ev) => {
      const index = ev.currentTarget.getAttribute("data-index");
      let hours = this.state.hours;
      hours[index] = false;
      hours = hours.filter((hour) => hour !== false);

      this.setState({ hours });
      setTimeout(this.updateHours, 0);
    };
    setFromHour = (value, index) => {
      let hours = this.state.hours;
      hours[index].from = value;

      this.setState({ hours });
      setTimeout(this.updateHours, 0);
    };
    setToHour = (value, index) => {
      let hours = this.state.hours;
      hours[index].to = value;

      this.setState({ hours });
      setTimeout(this.updateHours, 0);
    };
    hours = () => {


      if (this.state.hours && this.state.hours.length > 0) {
        return this.state.hours.map((hour, index) => (
          <Hour
            index={index}
            label={this.label}
            deleteFunction={this.deleteHour}
            setFrom={this.setFromHour}
            setTo={this.setToHour}
            hour={hour}
            hours={{
              opening_hours: this.props.opening_hours,
              closing_hours: this.props.closing_hours,
            }}
          />
        ));
      }
    };
    addHours = () => {
      let hoursCopy = this.state.hours.length ? this.state.hours : [];
      // console.log('dsffd_DFFDDFDF_', hoursCopy)
      if (hoursCopy.length === 0) {
        hoursCopy.push({
          from: "09:00",
          to: "17:00",
        });
        this.setState({ hours: hoursCopy });
        setTimeout(this.updateHours, 0);
      }
    };
    componentDidMount = () => {
      if (this.state.opened) this.addHours();
    };
    updateHours = () => {
      if (this.props.updateHours) {
        this.props.updateHours({
          [this.label]: this.state.opened ? this.state.hours : false,
        });
        //  
      }
    };

    render() {
      if (this.props.openHours?.[this.label] && !this.hasSetOpenHours) {
        // this.toggle()
        this.setState({
          opened: true,
          hours: this.props.openHours[this.label],
        });
        this.hasSetOpenHours = true;
      }
      return (
        <div className="time" >
          <div className="header  space-btw">
            <div className="day">{this.label}</div>
            <ToggleButton
              OnChange={this.toggle}
              data_open={this.state.opened}
              label={this.state.opened === true ? this.props.openedName ?? "opened" : this.props.closedName ?? "closed"}
            />
          </div>
          {this.state.opened === true ? (
            <div className="all-hours">
              {this.hours()}
              {/* <button className="co-pink" onClick={this.addHours}>
                Add hours
              </button> */}

            </div>
          ) : (
            ""
          )}
          <br />
        </div>

      );
    }
  }
);

function parseTime(t, h) {
  var d = new Date();
  if (t) {
    var time = t.match(/(\d+)(?::(\d\d))?\s*(p?)/);
    d.setHours(parseInt(time[1]) + (time[3] ? 12 : 0));
    d.setMinutes(parseInt(time[2]) || 0);

    d.setTime(d.getTime() + (h * (60 * 60 * 1000)));
    return d.toLocaleString('en-US', { hour: "numeric", minute: "numeric", hour12: false });
  }
  return null;
}


// function parseTimeRaw   (t)  {
//    

//   if(t)
//   {
//   var d = new Date();
//   var time = t.match( /(\d+)(?::(\d\d))?\s*(p?)/ );
//   d.setHours( parseInt( time[1]) + (time[3] ? 12 : 0) );
//   d.setMinutes( parseInt( time[2]) || 0 );
// return d.getTime();
//   }

// }

function Hours({
  index,
  setFrom,
  setTo,
  label,
  key,
  hour,
  hours: { opening_hours, closing_hours },
}) {
  const runSetFrom = (value) => {
    //  
    setFrom(value, index);
    // let date_new = parseTime(value, 8);
    // let min_new = parseTime(value,1);
    // setTo(date_new, index);
  };
  const runSetTo = (value, pos, label) => {
    //  

    setTo(value, index);


  };
 
  function roundToNext30(timeStr) {

    return timeStr;
    if (!timeStr) return null;
  
    let [hours, minutes] = timeStr.split(":").map(Number);
  
    if (minutes < 30) {
      minutes = 30;
    } else {
      hours = (hours + 1) % 24; // wrap around at 24
      minutes = 0;
    }
  
    const hh = String(hours).padStart(2, "0");
    const mm = String(minutes).padStart(2, "0");
  
    return `${hh}:${mm}`;
  }
  

  return (
    <>


      <TimePicker key={label + '_start'} amPmAriaLabel="true" format="h:mm a" required id={label} className={label + ' ' + label + '_start starttime'}
        disableClock={true} onChange={(value) => runSetFrom(roundToNext30(value))}
        value={hour.from === '00:00' ? '9:00' : hour.from}
        minuteInterval={30}
      />

      <span className="seperator" >-</span>

      <TimePicker key={label + '_end'} required id={label} amPmAriaLabel="true" format="h:mm a" className={label + ' ' + label + '_end endtime'}
        minuteInterval={30} disableClock={true} onChange={(value) => runSetTo(roundToNext30(value), 'end', label)} value={hour.to === '00:00' ? '17:00' : hour.to} />
    </>
  );
}

function Hour({
  // key,
  index,
  deleteFunction,
  label,
  setFrom,
  setTo,
  hour,
  ...props
}) {
  return (
    <div className="input-grid">
      {/* {index} */}
      <Hours
        index={index}
        label={label}
        setFrom={setFrom}
        setTo={setTo}
        hour={hour}
        {...props}
      />
      {/* <button
        className="seperator"
        type="button"
        onClick={deleteFunction}
        data-index={index}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.678 5.34156L5.34155 13.678C5.01269 14.0068 5.01269 14.54 5.34155 14.8689C5.67041 15.1978 6.20361 15.1978 6.53247 14.8689L14.8689 6.53248C15.1977 6.20362 15.1977 5.67043 14.8689 5.34156C14.54 5.0127 14.0068 5.0127 13.678 5.34156Z"
            fill="#2A2B79"
          />
          <path
            d="M14.8689 13.678L6.53247 5.34155C6.20361 5.01269 5.67042 5.01269 5.34155 5.34155C5.01269 5.67041 5.01269 6.20361 5.34155 6.53247L13.678 14.8689C14.0068 15.1977 14.54 15.1977 14.8689 14.8689C15.1978 14.54 15.1978 14.0068 14.8689 13.678Z"
            fill="#2A2B79"
          />
        </svg>
      </button> */}
    </div>
  );
}
